import { UserEntity, UserId } from "../../../entities";
import { Password } from "../../../value-objects";
const UserRegistrationRequestSchema = UserEntity.schema
    .omit({
    id: true,
    version: true,
    isDisabled: true,
    disabledAt: true,
    tenantId: true,
})
    .extend({
    password: Password.schema,
});
export const UserRegistrationRequest = {
    schema: UserRegistrationRequestSchema,
};
const UserRegistrationRequestWithIdSchema = UserRegistrationRequestSchema.extend({
    id: UserId.schema,
});
export const UserRegistrationRequestWithId = {
    schema: UserRegistrationRequestWithIdSchema,
};
const UserUpdateBasicRequestSchema = UserEntity.schema.pick({
    familyName: true,
    familyNameKana: true,
    givenName: true,
    givenNameKana: true,
    officeIds: true,
    segmentIds: true,
    version: true,
});
export const UserUpdateBasicRequest = {
    schema: UserUpdateBasicRequestSchema,
};
const UserUpdateRoleRequestSchema = UserEntity.schema.pick({
    userRole: true,
    roleId: true,
    version: true,
});
export const UserUpdateRoleRequest = {
    schema: UserUpdateRoleRequestSchema,
};
const UserUpdatePasswordRequestSchema = UserEntity.schema
    .pick({
    version: true,
})
    .extend({
    password: Password.schema,
});
export const UserUpdatePasswordRequest = {
    schema: UserUpdatePasswordRequestSchema,
};
const UserDisableRequestSchema = UserEntity.schema.pick({
    version: true,
});
export const UserDisableRequest = {
    schema: UserDisableRequestSchema,
};
//# sourceMappingURL=users-request.js.map